//jQuery(document).foundation();

console.log('disable found');